// extracted by mini-css-extract-plugin
module.exports = {"modalImage":"offermodalhero_modalImage__gVeOw","offerLegal":"offermodalhero_offerLegal__0_lSp"};